export const noop = (): void => {
    /**/
};
